import { CheckCircleOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import AutomationsCriteriaConditionsWrapper from 'automations/components/Nodes/AutomationsCriteriaConditionsWrapper';
import IfNodeContent from 'automations/components/Nodes/IfNodeContent';
import { type IfNodeType, nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ConditionNodeReturnProps } from './useConditionNodeConfig';

export default function useIf(node: NodeProps<IfNodeType>): ConditionNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.IfNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <IfNodeContent node={node} />, [node]);

  const subTitle = useMemo(() => {
    if (node.data?.additionalOptions?.criteriaGroupId) {
      return (
        <AutomationsCriteriaConditionsWrapper
          criteriaId={node.data.additionalOptions.criteriaGroupId}
          onCriteriaChange={() => {}}
          builderUi={() => null}
          textOnly
          renderFilters
        />
      );
    }
    return null;
  }, [node.data?.additionalOptions?.criteriaGroupId]);

  return {
    icon: CheckCircleOutlined,
    subTitle,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    targetHandle: {},
    AdditionalUI,
  };
}
